export function resolveInitialSwatchId(tileEntity: State.TileEntity): string {
  return tileEntity.selectedColorSwatchDesignId || tileEntity.designId
}
